import marioPhoto from "@/assets/team-mario.jpg";
import luisaPhoto from "@/assets/team-luisa.jpg";
import marceloPhoto from "@/assets/team-marcelo.jpg";
import isabelaPhoto from "@/assets/team-isabela.jpg";

export type TeamMember = {
  name: string;
  role: string;
  bio: string;
  photo: string;
  initials: string;
  accent: string;
};

export const TEAM: TeamMember[] = [
  {
    name: "Mario Jorge",
    role: "Responsável técnico",
    bio: "Coordena as vistorias e assina os laudos de dedetização exigidos pela Vigilância Sanitária.",
    initials: "MJ",
    accent: "#16A34A",
    photo: marioPhoto,
  },
  {
    name: "Luísa Fontes",
    role: "Atendimento e agendamento",
    bio: "Atende no WhatsApp, tira dúvidas e agenda a visita técnica gratuita em Chapecó e região.",
    initials: "LF",
    accent: "#111111",
    photo: luisaPhoto,
  },
  {
    name: "Marcelo Andrade",
    role: "Aplicador — Residencial e comercial",
    bio: "Executa dedetização, desratização e descupinização em casas, comércios e escritórios.",
    initials: "MA",
    accent: "#16A34A",
    photo: marceloPhoto,
  },
  {
    name: "Isabela Prado",
    role: "Aplicadora — Indústria e condomínios",
    bio: "Cuida do Manejo Integrado de Pragas em indústrias, condomínios e áreas comuns.",
    initials: "IP",
    accent: "#111111",
    photo: isabelaPhoto,
  },
];
